/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Rationale_LedeInputs */

const en_us2_push_rationale_lede = /** @type {(inputs: Push_Rationale_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only four kinds. You can turn each one off any time in your profile.`)
};

const pt_br2_push_rationale_lede = /** @type {(inputs: Push_Rationale_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São só quatro tipos. Dá para desligar cada um quando quiser, no perfil.`)
};

const es_419_push_rationale_lede = /** @type {(inputs: Push_Rationale_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son solo cuatro tipos. Puedes desactivar cada uno cuando quieras, en tu perfil.`)
};

const pt_pt2_push_rationale_lede = /** @type {(inputs: Push_Rationale_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São só quatro tipos. Podes desligar cada um quando quiseres, no perfil.`)
};

const fr_fr2_push_rationale_lede = /** @type {(inputs: Push_Rationale_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seulement quatre types. Tu peux désactiver chacun quand tu veux, dans ton profil.`)
};

const de_de2_push_rationale_lede = /** @type {(inputs: Push_Rationale_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur vier Arten. Du kannst jede jederzeit in deinem Profil ausschalten.`)
};

const it_it2_push_rationale_lede = /** @type {(inputs: Push_Rationale_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo quattro tipi. Puoi disattivarli uno per uno quando vuoi, nel profilo.`)
};

/**
* | output |
* | --- |
* | "Only four kinds. You can turn each one off any time in your profile." |
*
* @param {Push_Rationale_LedeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_rationale_lede = /** @type {((inputs?: Push_Rationale_LedeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Rationale_LedeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_rationale_lede(inputs)
	if (locale === "es-419") return es_419_push_rationale_lede(inputs)
	if (locale === "pt-PT") return pt_pt2_push_rationale_lede(inputs)
	if (locale === "fr-FR") return fr_fr2_push_rationale_lede(inputs)
	if (locale === "de-DE") return de_de2_push_rationale_lede(inputs)
	if (locale === "it-IT") return it_it2_push_rationale_lede(inputs)
	return en_us2_push_rationale_lede(inputs)
});
export { push_rationale_lede as "push.rationale_lede" }